/**
 * MBTI类型数据
 * 使用Map结构存储，key为MBTI code，value为完整信息
 */

// MBTI类型列表（按显示顺序）
const mbtiTypesList = [
  {
    code: 'INTJ',
    image: require('@/views/mbti-selection/assets/img/mbti/intj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/intj-selected.png')
  },
  {
    code: 'INFJ',
    image: require('@/views/mbti-selection/assets/img/mbti/infj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/infj-selected.png')
  },
  {
    code: 'ISTJ',
    image: require('@/views/mbti-selection/assets/img/mbti/istj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/istj-selected.png')
  },
  {
    code: 'ISTP',
    image: require('@/views/mbti-selection/assets/img/mbti/istp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/istp-selected.png')
  },
  {
    code: 'INTP',
    image: require('@/views/mbti-selection/assets/img/mbti/intp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/intp-selected.png')
  },
  {
    code: 'INFP',
    image: require('@/views/mbti-selection/assets/img/mbti/infp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/infp-selected.png')
  },
  {
    code: 'ISFJ',
    image: require('@/views/mbti-selection/assets/img/mbti/isfj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/isfj-selected.png')
  },
  {
    code: 'ISFP',
    image: require('@/views/mbti-selection/assets/img/mbti/isfp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/isfp-selected.png')
  },
  {
    code: 'ENTJ',
    image: require('@/views/mbti-selection/assets/img/mbti/entj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/entj-selected.png')
  },
  {
    code: 'ENFJ',
    image: require('@/views/mbti-selection/assets/img/mbti/enfj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/enfj-selected.png')
  },
  {
    code: 'ESTJ',
    image: require('@/views/mbti-selection/assets/img/mbti/estj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/estj-selected.png')
  },
  {
    code: 'ESTP',
    image: require('@/views/mbti-selection/assets/img/mbti/estp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/estp-selected.png')
  },
  {
    code: 'ENTP',
    image: require('@/views/mbti-selection/assets/img/mbti/entp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/entp-selected.png')
  },
  {
    code: 'ENFP',
    image: require('@/views/mbti-selection/assets/img/mbti/enfp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/enfp-selected.png')
  },
  {
    code: 'ESFJ',
    image: require('@/views/mbti-selection/assets/img/mbti/esfj.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/esfj-selected.png')
  },
  {
    code: 'ESFP',
    image: require('@/views/mbti-selection/assets/img/mbti/esfp.png'),
    selectedImage: require('@/views/mbti-selection/assets/img/mbti/esfp-selected.png')
  }
]

// 创建Map结构，key为code，value为完整信息
const mbtiTypesMap = new Map()
mbtiTypesList.forEach(mbti => {
  mbtiTypesMap.set(mbti.code, mbti)
})

// 根据code获取MBTI信息
const getMbtiByCode = (code) => {
  return mbtiTypesMap.get(code)
}

export {
  mbtiTypesList,
  mbtiTypesMap,
  getMbtiByCode
}

